import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { environment } from 'src/environments/environment';
import { API_URL } from './../enums/api-enums';
import { GetAllResponse, SingleResponse } from './../model/restful-api.model';
import { RequestOption } from '../model/common.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FiberglassFilter, SupplierFormFilter } from '../model/eol-setups.model';

@Injectable({
  providedIn: 'root'
})
export class SrmService {

  private baseUrl = `${environment.portalURL}`;
  private type = 'application/json';
  constructor(
    private util: UtilitiesService,
    private http: HttpClient,
  ) { }

  getWelcomeMessage(): Observable<SingleResponse<any>> {
    const url = this.baseUrl + API_URL.SRM_WELCOME_MESSAGE;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  getLandingPage(): Observable<SingleResponse<any>> {
    const url = this.baseUrl + API_URL.SRM_LANDINGPAGE;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  getDataGaugeChart(): Observable<GetAllResponse<any>> {
    const url = this.baseUrl + API_URL.SCORE_CARD + '/kpi-gauge';
    return this.util.req.httpGet<GetAllResponse<any>>(url);
  }

  updateWelcomeMesage(request, newAvatar, newImage) {
    const url = this.baseUrl + API_URL.SRM_WELCOME_MESSAGE;
    const formData = new FormData();
    if (newAvatar !== '') {
      formData.append('new-avatar', newAvatar);
    }
    if (newImage !== '') {
      formData.append('new-image', newImage);
    }
    formData.append('welcome-message', new Blob([btoa(unescape(encodeURIComponent(this.util.encrypt(JSON.stringify(request)))))], {type: this.type}));
    return this.util.req.httpPut(url, formData);
  }

  getSections(): Observable<GetAllResponse<any>> {
    const url = this.baseUrl + API_URL.SRM_SECTION;
    return this.util.req.httpGet<GetAllResponse<any>>(url);
  }

  getSectionById(id): Observable<SingleResponse<any>> {
    const url =  this.baseUrl + API_URL.SRM_SECTION + '/' + id;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  addSections(requestModel) {
    const url = this.baseUrl + API_URL.SRM_SECTION;
    return this.util.req.httpPost(url, requestModel);
  }

  updateSections(requestModel) {
    const url = this.baseUrl + API_URL.SRM_SECTION;
    return this.util.req.httpPut(url, requestModel);
  }

  deleteSections(id) {
    const url = this.baseUrl + API_URL.SRM_SECTION + '/' + id;
    return this.util.req.httpDelete(url);
  }

  getApplicationLinksBySectionId(id): Observable<SingleResponse<any>> {
    const url = this.baseUrl + API_URL.SRM_APPLICATION_LINK + '?sectionId=' + id;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  addApplicationLinks(requestModel, file) {
    const url = this.baseUrl + API_URL.SRM_APPLICATION_LINK;
    const formData = new FormData();
    formData.append('icon', file);
    formData.append('application-link', new Blob([JSON.stringify(requestModel)], {type: this.type}));
    return this.util.req.httpPost(url, formData);
  }

  getApplicationLinkById(id): Observable<SingleResponse<any>> {
    const url = this.baseUrl + API_URL.SRM_APPLICATION_LINK + '/' + id;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  updateApplicationLink(requestModel, file) {
    const url = this.baseUrl + API_URL.SRM_APPLICATION_LINK;
    const formData = new FormData();
    if (file) {
      formData.append('icon', file);
    }
    formData.append('application-link', new Blob([JSON.stringify(requestModel)], {type: this.type}));
    return this.util.req.httpPut(url, formData);
  }

  deleteApplicationLink(id) {
    const url = this.baseUrl + API_URL.SRM_APPLICATION_LINK + '/' + id;
    return this.util.req.httpDelete(url);
  }

  uploadRatingGuileLine(file, type) {
    const formData = new FormData();
    formData.append('file', file);
    return this.util.req.httpPost(this. baseUrl + '/general-setting/rating-guideline/' + type, formData);
  }

  getSupplierDataTable(requestOption: RequestOption | any, search?: any, supplierGsl?: any, createdDateRange?: any) {
    const url = this.baseUrl + API_URL.SUPPLIER_FORM;
    let params = new HttpParams();

    if (requestOption?.pagingOptions?.sort?.sortBy && requestOption?.pagingOptions?.sort?.sortOrder) {
      params = params.append('sortBy', requestOption?.pagingOptions?.sort?.sortBy);
      params = params.append('sortDirection', requestOption?.pagingOptions?.sort?.sortOrder);
    }
    if (search) {
      params = params.append('searchKey', search);
    }
    if (supplierGsl) {
      params = params.append('supplierGsl', supplierGsl);
    }
    if (createdDateRange && createdDateRange.createdDateFrom) {
        params = params.append('createdDateFrom', createdDateRange.createdDateFrom);
    }
    if (createdDateRange && createdDateRange.createdDateTo) {
        params = params.append('createdDateTo', createdDateRange.createdDateTo);
    }
    params = params.append('size', requestOption?.pagingOptions?.size?.toString());
    params = params.append('page', requestOption?.pagingOptions?.number?.toString());

    return this.util.req.httpGet<SingleResponse<any>>(`${url}?${params}`);
  }

  getSupplierFormDetails(id: number | string) {
    const url = this.baseUrl + API_URL.SUPPLIER_FORM + '/' + id;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  createSupplierForm(requestModel: any) {
    const url = this.baseUrl + API_URL.SUPPLIER_FORM;
    return this.util.req.httpPost(url, requestModel);
  }

  updateSupplierForm(requestModel: any) {
    const url = this.baseUrl + API_URL.SUPPLIER_FORM;
    return this.util.req.httpPut(url, requestModel);
  }

  deleteSupplierForm(id: number | string): Observable<SingleResponse<any>> {
    const url = this.baseUrl + API_URL.SUPPLIER_FORM + '/' + id;
    return this.util.req.httpDelete(url);
  }

  getFiberglassDataTable(requestOption: RequestOption | any, search?: any, createdBy?: any, createdDateRange?: any) {
    const url = this.baseUrl + API_URL.FIBERGLASS_PROCESSING_FORM;
    let params = new HttpParams();

    if (requestOption?.pagingOptions?.sort?.sortBy && requestOption?.pagingOptions?.sort?.sortOrder) {
      params = params.append('sortBy', requestOption?.pagingOptions?.sort?.sortBy);
      params = params.append('sortDirection', requestOption?.pagingOptions?.sort?.sortOrder);
    }
    if (search) {
      params = params.append('searchKey', search);
    }
    if (createdBy) {
      params = params.append('createdBy', createdBy);
    }
    if (createdDateRange && createdDateRange.createdDateFrom) {
        params = params.append('createdDateFrom', createdDateRange.createdDateFrom);
    }
    if (createdDateRange && createdDateRange.createdDateTo) {
        params = params.append('createdDateTo', createdDateRange.createdDateTo);
    }
    params = params.append('size', requestOption?.pagingOptions?.size?.toString());
    params = params.append('page', requestOption?.pagingOptions?.number?.toString());

    return this.util.req.httpGet<SingleResponse<any>>(`${url}?${params}`);
  }

  getFiberglassDetails(id: number | string) {
    const url = this.baseUrl + API_URL.FIBERGLASS_PROCESSING_FORM + '/' + id;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  createFiberglass(requestModel: any) {
    const url = this.baseUrl + API_URL.FIBERGLASS_PROCESSING_FORM;
    return this.util.req.httpPost(url, requestModel);
  }

  updateFiberglass(requestModel: any) {
    const url = this.baseUrl + API_URL.FIBERGLASS_PROCESSING_FORM;
    return this.util.req.httpPut(url, requestModel);
  }

  deleteFiberglass(id: number | string): Observable<SingleResponse<any>> {
    const url = this.baseUrl + API_URL.FIBERGLASS_PROCESSING_FORM + '/' + id;
    return this.util.req.httpDelete(url);
  }

  exportSupplierForm(ids: number[]) {
    // const params: any = {};
    // Object.keys(filter).forEach((key) => {
    //   const value = (filter as any)[key];
    //   const normalizedValue = typeof value === 'string' ? value.trim() : value;
    //   if (normalizedValue !== undefined && normalizedValue !== null && normalizedValue !== '') {
    //     params[key] = normalizedValue;
    //   }
    // });
    const url = this.baseUrl + API_URL.SUPPLIER_FORM + '/export';
    return this.http.post(`${url}`, ids, {
      responseType: 'arraybuffer'
    });
  }

  exportFiberglass(ids: number[]) {
    // const params: any = {};
    // Object.keys(filter).forEach((key) => {
    //   const value = (filter as any)[key];
    //   const normalizedValue = typeof value === 'string' ? value.trim() : value;
    //   if (normalizedValue !== undefined && normalizedValue !== null && normalizedValue !== '') {
    //     params[key] = normalizedValue;
    //   }
    // });
    const url = this.baseUrl + API_URL.FIBERGLASS_PROCESSING_FORM + '/export';
    return this.http.post(`${url}`, ids, {
      responseType: 'arraybuffer'
    });
  }
}
